<script>
    import axios from 'axios'
    import 'vue3-swatches/dist/style.css'
    import {Listeners} from "../../../constants/listeners";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import {store} from "../store";
    import Fieldset from "primevue/fieldset";
    import Checkbox from "primevue/checkbox";
    import Alerts from "../../../mixins/Alerts";
    import ColorPicker from "primevue/colorpicker";

    export default {
        mixins: [Alerts],
        data () {
            return {
                name: "TreeSetting",
                loading: false,
                error: null,
                model: {
                    view:{
                        treeNodeName: {
                            sumIt1: {},
                            sumIt3: {},
                            sumIt5: {},
                            sumIt10: {},
                            sumIt50: {},
                            sumVis: {}
                        }
                    },
                    sort: {
                        field: null,
                        dir: null
                    }
                },
                store: store,
            }
        },
        methods: {
            setSetting(setting) {
                this.store.mutations.setSetting(setting);
            },
            save() {
                let self = this;
                self.loading = true;
                axios({
                    method: 'post',
                    url: this.apiUrl,
                    withCredentials: true,
                    data: this.model
                })
                .then(function (response) {
                    self.setSetting(self.model);
                    self.loading = false;
                    self.alertInfo(self.$t('lang.report.treepages.setting_success'));

                    self.onClose();
                }).catch(function (error) {
                    self.alertError(error.response.data.message);

                });
            },
            enabled(field, dir) {
                return {'sort_enabled': this.model.sort.field === field && this.model.sort.dir === dir};
            },
            toggle(field, dir) {
                this.model.sort = {
                    field: field,
                    dir: dir
                }
            },
            onClose() {
                this.$emitter.emit(this.getListenerDialogClose);
                location.reload();
            },
            onOpen() {
                this.model = this.getSetting;
            }
        },
        computed: {
            getSetting() {
                return this.store.getters.setting();
            },
            apiUrl(){
                return this.$config.API_URL + '/report/simple/organic/tree_pages/setting';
            },
            getListenerDialogOpen() {
                return Listeners.TREE_PAGES_POPUP_SETTING_OPEN;
            },
            getListenerDialogClose() {
                return Listeners.TREE_PAGES_POPUP_SETTING_CLOSE;
            }
        },
        components: {
            ColorPicker,
            AdaptersDialog,
            Fieldset,
            Checkbox,
        }
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getListenerDialogOpen"
        :listener-close-id="getListenerDialogClose"
        :callback-on-show="onOpen"
        :header="$t('lang.report.treepages.main_setting')"
        :loading="loading"
        :callback-agree="save"
        :button-agree-label="$t('lang.main.btn.save')"
    >
        <template #content>
            <Fieldset :legend="$t('lang.report.treepages.display_folder')">
                <table>
                    <thead>
                    <tr>
                        <th colspan="2"><span>{{$t('lang.report.treepages.value')}}</span></th>
                        <th><span>{{$t('lang.report.treepages.color')}}</span></th>
                        <th><span>{{$t('lang.report.treepages.background')}}</span></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><Checkbox v-model="model.view.treeNodeName.sumIt1.enabled" binary /></td>
                            <td>{{$t('lang.report.treepages.common_it_1')}}</td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt1.color" /></div></td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt1.background" /></div></td>
                        </tr>
                        <tr>
                            <td><Checkbox v-model="model.view.treeNodeName.sumIt3.enabled" binary /></td>
                            <td>{{$t('lang.report.treepages.common_it_3')}}</td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt3.color" /></div></td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt3.background" /></div></td>
                        </tr>
                        <tr>
                            <td><Checkbox v-model="model.view.treeNodeName.sumIt5.enabled" binary /></td>
                            <td>{{$t('lang.report.treepages.common_it_5')}}</td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt5.color" /></div></td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt5.background" /></div></td>
                        </tr>
                        <tr>
                            <td><Checkbox v-model="model.view.treeNodeName.sumIt10.enabled" binary /></td>
                            <td>{{$t('lang.report.treepages.common_it_10')}}</td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt10.color" /></div></td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt10.background" /></div></td>
                        </tr>
                        <tr>
                            <td><Checkbox v-model="model.view.treeNodeName.sumIt50.enabled" binary /></td>
                            <td>{{$t('lang.report.treepages.common_it_50')}}</td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt50.color" /></div></td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumIt50.background" /></div></td>
                        </tr>
                        <tr>
                            <td><Checkbox v-model="model.view.treeNodeName.sumVis.enabled" binary /></td>
                            <td>{{$t('lang.report.treepages.common_traff')}}</td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumVis.color" /></div></td>
                            <td align="center"><div class="card flex justify-content-center"><ColorPicker v-model="model.view.treeNodeName.sumVis.background" /></div></td>
                        </tr>
                    </tbody>
                </table>
            </Fieldset>
        </template>
    </AdaptersDialog>
</template>
<style scoped>
    fieldset label {margin: 0;}
    .radio{width: 100%}
    .span_sort{cursor: pointer}
    .sort{color: #eee}
    .sort_enabled{color: #000}
    :deep(.p-colorpicker-preview) {width: 15px; height: 15px; border-radius: 50%;}
</style>
